import { Box, Loader } from '@mantine/core'
import React from 'react'

const LoadingPage: React.FC = () => {
  return (
    <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Loader size="xl" />
    </Box>
  );
};

export default LoadingPage;